/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchTerm/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconSearch from 'DesignSystem/Svgs/TysiaIconSearch/index'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function SearchTerm({
  children,
  viewPath = "/DesignSystem/TasksFilters/Patient/Content/SearchTerm",
  onChange
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let patientPickerSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'patient_picker',
path: 'search_term',
})
let patientPickerSearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'patient_picker',
path: 'search_term',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 marginBottom={0}
 autoFocus={true}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 borderTopLeftRadius={0}
 borderTopRightRadius={0}
 borderBottomRightRadius={0}
 borderBottomLeftRadius={0}
 borderWidth={0}
>
{childProps => (
<React.Fragment>
<TysiaIconSearch
{...childProps}
  viewPath={`${viewPath}/TysiaIconSearch`}
 marginRight={dtSpaceMs}
 width={18}
 height={18}
 fill={dtColorsNeutral400}
/>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 data="patient_picker.search_term"
 value={patientPickerSearchTermValueData}
 onChange={patientPickerSearchTermChangeData}
 placeholder="Search"
/>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}